import { render, staticRenderFns } from "./HolidayList.vue?vue&type=template&id=1f122b5a&scoped=true"
import script from "./HolidayList.vue?vue&type=script&lang=js"
export * from "./HolidayList.vue?vue&type=script&lang=js"
import style0 from "./HolidayList.vue?vue&type=style&index=0&id=1f122b5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.10.0_vue-template-compiler@2.6.14_webpack@5.91.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f122b5a",
  null
  
)

export default component.exports